import { useEffect } from "react";
import { Container } from "reactstrap";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { Navigate } from "react-router-dom";
import { logout } from "../../store/slices/loginSlice";
import HerdSelector from "../components/HerdSelector";
import AnimalList from "../components/AnimalList";

function Home(props: any) {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector((state) => state.login.authenticated);
    const showHerdSelector = useAppSelector((state) => state.app.showHerdSelector);
    const showAnimalList = useAppSelector((state) => state.app.showAnimalList);
    const isAuthorized = useAppSelector((state) => state.app.userIsAuthorized);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("state") === "pkceLogout") {
      dispatch(logout());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isAuthenticated) {
    return (
        <Container className="py-3 px-3">

            {isAuthorized && showHerdSelector && (
                <HerdSelector />
            )}

            {isAuthorized && showAnimalList && (
                <AnimalList />
            )}
        </Container>
    );
  } else {
    return <Navigate to="/login" replace={true} />;
  }
}

export default Home;
